export default "__VITE_ASSET__B$WKIcBs__"